import { Button, ButtonGroup, Col, Container, Form, Row } from "react-bootstrap";
import { CheckLg, PencilFill, XLg } from "react-bootstrap-icons";

export default function PredictorSettingsRow({ settings, editing, invalid, minWidth = 0, onChange, onEdit, onSave, onDiscard }) {
    const style = { minWidth: minWidth ? `max(${minWidth}px, 100%)` : "100%" };

    return (
        <Container fluid style={style}>
            <Row className="py-1 border-bottom hoverable-no-pointer align-items-center">
                <Col xs={2}>
                    <SettingsInput field="look_back_weeks" settings={settings} editing={editing} onChange={onChange} />
                </Col>
                <Col xs={2}>
                    <SettingsInput field="max_spins" settings={settings} editing={editing} onChange={onChange} />
                </Col>
                <Col xs={2}>
                    <SettingsInput field="max_song_age_weeks" settings={settings} editing={editing} onChange={onChange} />
                </Col>
                <Col>
                    <Row>
                        <Col xs={6}>
                            <SettingsInput field="song_release_start" settings={settings} editing={editing} onChange={onChange} />
                        </Col>
                        <Col xs={6}>
                            <SettingsInput field="song_release_end" settings={settings} editing={editing} onChange={onChange} />
                        </Col>
                    </Row>
                </Col>
                <Col xs="auto" className="d-flex justify-content-center" style={{ width: 108 }}>
                    <ButtonGroup size="sm">
                        {!editing ? (
                            <Button variant="ra-yellow" title="Edit" onClick={onEdit}>
                                <PencilFill size={20} />
                            </Button>
                        ) : (
                            <>
                                <Button variant="success" title="Save" onClick={onSave} disabled={invalid}>
                                    <CheckLg size={20} />
                                </Button>
                                <Button variant="danger" title="Discard" onClick={onDiscard}>
                                    <XLg size={20} />
                                </Button>
                            </>
                        )}
                    </ButtonGroup>
                </Col>
            </Row>
        </Container>
    );
}

function SettingsInput({ field, settings, editing, onChange }) {
    return (
        <Form.Control
            type="number"
            min={0}
            value={settings[field] ?? ""}
            plaintext={!editing}
            readOnly={!editing}
            size="sm"
            className="text-center"
            onChange={e => onChange(field, e.target.value)}
        />
    );
}
